// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sheet__img[data-v-ad5ab724]{display:block;max-width:100%}", ""]);
// Exports
module.exports = exports;
